(function () {
  'use strict';
  if (window.somniumThemeMode) {
    window.somniumThemeMode.refresh();
    return;
  }

  var mode = 'dark';
  function readMode() {
    try {
      var stored = window.localStorage.getItem('lightMode');
      if (stored === 'light' || stored === 'dark') return stored;
    } catch (error) { /* Private browsing/storage policy must not break the page. */ }
    return mode;
  }
  function saveMode(value) {
    mode = value;
    try { window.localStorage.setItem('lightMode', value); } catch (error) { /* Keep an in-memory preference. */ }
  }
  function refresh() {
    mode = readMode();
    if (document.body) document.body.setAttribute('light-mode', mode);
    var label = window.theme && window.theme[mode === 'dark' ? 'darkMode' : 'lightMode'];
    if (typeof label === 'string') {
      document.querySelectorAll('.theme-mode-label .mode-button-text').forEach(function (element) {
        element.textContent = label;
      });
    }
  }

  // One delegated handler also covers header sections inserted by the editor.
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest || !event.target.closest('.light-mode')) return;
    event.preventDefault();
    saveMode(mode === 'dark' ? 'light' : 'dark');
    refresh();
  });
  window.addEventListener('storage', function (event) {
    if (event.key === 'lightMode' || event.key === null) refresh();
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  window.somniumThemeMode = { refresh: refresh };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
